<template>
  <div class="content company_search">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <h1 class="section_header px-4">Company Search</h1>
        <div class="search_area">
          <h2>Company Search</h2>
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-40 md-size-40 field_wpr">
              <md-field>
                <md-input
                  type="text"
                  value=""
                  v-model="companyName"
                  placeholder="Company name"
                />
                <md-icon>search</md-icon>
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-50 md-size-50 field_wpr">
              <md-field :class="{ 'md-invalid': stateProvinceError }">
                <!-- <label>State</label> -->
                <md-select
                  v-model="stateProvince"
                  name="states"
                  placeholder="State"
                >
                  <md-option
                    v-for="state in states"
                    :key="state.name"
                    :value="state.code"
                    >{{ state.name }}</md-option
                  >
                </md-select>
                <span class="md-error" v-if="!!stateProvince"
                  >This field is required.</span
                >
              </md-field>
            </div>
            <div
              class="md-layout-item md-medium-size-10 md-size-10 field_wpr"
              md-alignment="center"
            >
              <md-button @click="search()" class="md-info md-round"
                >Search</md-button
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 mb-4"
      >
        <div class="search_result">
          <div class="search_list" v-if="!showFavorites">
            <span class="profile_title">Companies</span>
            <div class="favorites hover" @click="switchFavorites(true)">
              <md-icon>star</md-icon>Favorite Companies
            </div>
            <div :class="{ hide: loaded }">
              <PulseLoader :loading="!loaded"></PulseLoader>
            </div>
            <div v-if="searchResults">
              <ul>
                <li v-for="item in searchResults" :key="item.label">
                  <div class="company_info">
                    <h4>
                      {{ item.label }}
                      <span
                        v-if="isFavorite(item)"
                        @click="unfavoriteCompany('list', item)"
                      >
                        <md-icon
                          :id="'star_' + item.locnum"
                          class="favorite-btn"
                          >star</md-icon
                        >
                      </span>
                      <span
                        v-if="!isFavorite(item)"
                        @click="favoriteCompany(item)"
                      >
                        <md-icon
                          :id="'star_' + item.locnum"
                          class="favorite-btn"
                          >star_border</md-icon
                        >
                      </span>
                    </h4>
                    <!-- <h6>Industry: {{ item.industry }}</h6> -->
                    <!-- <h6>ZIP Code: {{ item.zip }}</h6> -->
                  </div>
                  <md-button
                    v-if="isAccessible"
                    @click.native="openModal(item)"
                    class="md-info md-round"
                  >
                    <span>Access Now</span>
                  </md-button>
                  <md-button
                    v-else
                    @click.native="createProfile(item)"
                    class="md-info md-round"
                  >
                    <span>Add To Cart</span>
                  </md-button>
                </li>
              </ul>
              <div class="pagination">
                <!-- <p>Showing 1- {{ searchResults.length }}</p> -->
                <ul>
                  <li>
                    <md-button class="md-round" @click="prevPage()"
                      >Previous</md-button
                    >
                  </li>
                  <li>
                    <md-button class="md-round" @click="nextPage()"
                      >Next</md-button
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="!searchResults && loaded">
              No search results currently, please use the search tool to
              initiate search or make company name keyword search broader.
            </div>
          </div>
          <div class="search_list" v-if="showFavorites">
            <span class="profile_title">Favorite Companies</span>
            <div class="favorites hover" @click="switchFavorites(false)">
              <md-icon>search</md-icon>Company Search
            </div>
            <div v-if="favorites && favorites.length">
              <ul>
                <li v-for="item in favorites" :key="item.id">
                  <div class="company_info">
                    <h4>
                      {{ item.data }}
                      <span @click="unfavoriteCompany('id', item.id)">
                        <md-icon
                          :id="'star_' + item.search1"
                          class="favorite-btn"
                          >star</md-icon
                        >
                      </span>
                    </h4>
                    <!-- <h6>Industry: {{ item.industry }}</h6> -->
                    <!-- <h6>ZIP Code: {{ item.zip }}</h6> -->
                  </div>
                  <!-- <md-button
                    class="md-info md-round"
                    @click="
                      createProfile({ locnum: item.search1, zip: item.search2 })
                    "
                    >Add to Cart</md-button
                  > -->
                  <md-button
                    @click.native="
                      createProfile({ locnum: item.search1, zip: item.search2 })
                    "
                    class="md-info md-round"
                  >
                    <span v-if="!isAccessible">Access Now</span>
                    <span v-if="isAccessible">Add To Cart</span>
                  </md-button>
                </li>
              </ul>
            </div>
            <div v-if="!favorites || !favorites.length">
              No favorites currently.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prospect_content">
      <modal v-if="confirmationModal" @close="confirmationModal = false">
        <template slot="header">
          <button
            type="button"
            class="close_btn"
            @click="confirmationModal = false"
          >
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <div class="field_wpr">
            <h4 class="modal-title">
              Please confirm access to this product with the selected
              parameters. Click Review to review the parameters or Access Now to
              access this product.
            </h4>
            <div class="ml-4 md-layout">
              <md-button
                @click="confirmationModal = false"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40"
                >Review</md-button
              >
              <md-button
                @click="createProfile()"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40"
              >
                Access Now</md-button
              >
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import { localStates } from "@/assets/common/location";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { mapState } from "vuex";
import { Modal, PulseLoader } from "@/components";

export default {
  name: "CompanySearch",
  components: {
    PulseLoader,
    Modal,
  },
  data() {
    return {
      companyName: null,
      stateProvince: null,
      stateProvinceError: null,
      states: localStates,
      defaultScreen: null,
      defaultScreens: ["Profile Search"],
      validations: {
        stateProvince: {
          required,
        },
      },
      confirmationModal: false,
      loaded: true,
      searchResults: null,
      paginPage: 1,
      paginLength: 15,
      showFavorites: false,
      favorites: null,
      isAccessible: true,
      item: null,
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      setDefaultScreen: (state) =>
        state?.user?.user?.preferences?.defaultScreen,
      subscriptions: (state) => state.user.user_subscriptions ?? null,
    }),
  },
  watch: {
    stateProvince: function(val) {
      this.search();
    },
    subscriptions() {
      if (this.subscriptions && this.subscriptions.length > 0)
        this.checkAccessByType();
    },
  },
  methods: {
    ...mapActions({
      saveUserProfile: "profile/save",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    prevPage() {
      if (this.paginPage != 1) {
        this.paginPage = this.paginPage - 1;
        this.search();
      }
    },
    nextPage() {
      // if (this.paginPage != 1) {
      this.paginPage = this.paginPage + 1;
      this.search();
      // }
    },
    openModal(item) {
      this.confirmationModal = true;
      this.item = item;
    },
    async search() {
      if (this.companyName) {
        this.loaded = false;
        let params = {
          term: this.companyName ? this.companyName : "auto",
          page: this.paginPage,
          itemsPerPage: this.paginLength,
          state: this.stateProvince,
        };
        this.$store.dispatch("companyList/search", params).then((list) => {
          this.searchResults = list;
          this.loaded = true;
        });
      }
    },
    async createProfile(company = this.item) {
      let params = {
        locnum: company.locnum,
        zip: company.zip,
      };
      this.$store.dispatch("companyList/createProfile", params).then((res) => {
        let profileId = res.id;
        this.updatePullTime({ isFinishedDate: false, productId: profileId });
        this.access(profileId);
      });
    },
    async favoriteCompany(item) {
      let params = {
        category1: "company-list",
        category2: "company",
        data: item.label,
        search1: item.locnum,
        search2: item.zip,
      };

      this.$store
        .dispatch("companyList/favoriteCompany", params)
        .then((res) => {
          const elem = document.getElementById("star_" + item.locnum);
          elem.innerHTML = "star";
          this.$store.dispatch("alerts/success", "Favorite added.");
          this.getFavorites();
        });
    },
    async unfavoriteCompany(type, id) {
      if (type === "list") {
        id = await this.favoriteId(id);
      }

      let params = {
        favoriteID: id,
      };

      this.$store
        .dispatch("companyList/unfavoriteCompany", params)
        .then((res) => {
          this.getFavorites();
          this.$store.dispatch("alerts/success", "Favorite removed.");
        });
    },
    async getFavorites() {
      let params = {
        category1: "company-list",
        category2: "company",
      };

      this.$store.dispatch("companyList/favorites", params).then((res) => {
        this.favorites = res;
      });
    },
    checkAccess: async function() {
      let params = {
        product_id: this.profileId,
      };

      await this.$store
        .dispatch("cart/checkProductAccess", params)
        .then((res) => {
          const { access, ready } = res;
          this.isAccessible = access;
          this.productPrice = res.price;
        });
    },
    checkAccessByType: async function() {
      if (this.subscriptions.includes("css")) this.isAccessible = true;
      else this.isAccessible = false;
    },
    async access(profileId) {
      let params = {
        product_id: profileId,
      };

      await this.$store.dispatch("cart/accessProduct", params).then((res) => {
        if (res.cart) {
          this.$router.push({
            name: "Cart",
            params: { id: profileId },
          });
        }

        if (
          res.access ||
          (res.error && res.errorCode === "product_already_accessed")
        ) {
          this.$router.push({
            path: `/companies/${profileId}/profile/auxpage`,
          });
          //this.$router.push({ path: `/companies/${profileId}/profile` });
        }
      });
    },
    switchFavorites(state) {
      this.showFavorites = state;
    },
    isFavorite(item) {
      return this.favorites.filter((fav) => {
        return parseInt(fav.search1) === item.locnum;
      }).length;
    },
    favoriteId(item) {
      return this.favorites.filter((fav) => {
        return parseInt(fav.search1) === item.locnum;
      })[0].id;
    },
  },
  async mounted() {
    await this.getFavorites();
  },
};
</script>
<style scoped>
.hide {
  display: none;
}

.pulse_loader {
  background: transparent;
  height: 120px;
}

.favorite-btn:hover {
  cursor: pointer;
}
</style>
